(function (ws) {
    'use strict';
    ws.models.handsOnTableModel = Backbone.Model.extend({
        defaults: {
            partNo: '',
            isExpanded: true,
            type: 'STD'
        }
    });
})(westcon);
